<template>
  <div class="modal_wrap system internet_apply_popup" :class="{ on: show }">
    <div class="modal_inner" @click.self="applyPopupClose()">
      <div class="popup_inner" id="popup_inner">
        <div class="p_modal_wrap">
          <div class="p_top_wrap">
            <div class="p_top"></div>
          </div>
          <div class="p_modal">
            <div class="p_modal_con">
              <div class="apply_con" id="apply_con" ref="apply_con">
                <div class="top_bar_bg">
                  <div class="top_bar"></div>
                </div>
                <div class="top_txt" v-if="step == 'step1'">
                  <div class="txt_1">
                    <img
                      :src="
                        require('@/assets/front/images/v2/img_3_d_check.png')
                      "
                      alt=""
                    />
                  </div>
                  <div class="txt_2">신청서 전송이 완료 되었습니다!</div>
                  <div class="txt_3">
                    신청서 전송 이후엔 이런 과정이 남아있어요!
                  </div>
                </div>
                <div class="top_txt" v-else-if="step == 'step2'">
                  <div class="txt_1">
                    <img
                      :src="
                        require('@/assets/front/images/v2/img_3_d_porridge.png')
                      "
                      alt=""
                    />
                  </div>
                  <div class="txt_2">지원금 입금이 완료되었습니다!</div>
                  <div class="txt_3">
                    퍼스에서의 경험이 즐거웠다면 리뷰를 남겨주세요!
                  </div>
                </div>
                <div class="m_step_info">
                  <div class="m_step_txt">
                    <div class="txt_list_wrap">
                      <div class="point on"></div>
                      <div class="txt_list mb">
                        <div class="title_txt">신청서 전송</div>
                        <div class="txt h2">
                          가입을 위한 신청서 작성이 완료되었습니다.
                        </div>
                      </div>
                    </div>
                    <div class="txt_list_wrap">
                      <div
                        :class="step == 'step2' ? 'point on' : 'point_s'"
                      ></div>
                      <div class="txt_list mb">
                        <div class="title_txt">본인 인증</div>
                        <div class="txt">
                          가일을 위해서는 본인 인증이 필요합니다. 사장님이 전화
                          또는 채팅으로 안내해드립니다.
                        </div>
                      </div>
                    </div>
                    <div class="txt_list_wrap">
                      <div
                        :class="step == 'step2' ? 'point on' : 'point_s'"
                      ></div>
                      <div class="txt_list mb">
                        <div class="title_txt">설치 일정 조율</div>
                        <div class="txt">
                          가입 접수가 완료 되면 설치 기사님이 설치 일정 조율을
                          위해 전화가 갈 예정입니다.
                        </div>
                      </div>
                    </div>
                    <div class="txt_list_wrap">
                      <div
                        :class="step == 'step2' ? 'point on' : 'point_s'"
                      ></div>
                      <div class="txt_list mb">
                        <div class="title_txt">설치</div>
                        <div class="txt">
                          약속된 날짜에 설치기사님이 방문하여 설치를 완료합니다.
                        </div>
                      </div>
                    </div>
                    <div class="txt_list_wrap">
                      <div
                        :class="step == 'step2' ? 'point on' : 'point_s'"
                      ></div>
                      <div class="txt_list mb">
                        <div class="title_txt">설치 인증</div>
                        <div class="txt">
                          설치가 완료되었다면 사진을 찍어 사장님께 설치인증을
                          해야 지원금을 받을 수 있어요!
                        </div>
                      </div>
                    </div>
                    <div class="txt_list_wrap">
                      <div
                        :class="step == 'step2' ? 'point on' : 'point_s'"
                      ></div>
                      <div class="txt_list">
                        <div class="title_txt">지원금 입금</div>
                        <div class="txt">
                          사장님은 설치인증 후 지원금을 당일 또는 익일
                          입금합니다.
                        </div>
                      </div>
                    </div>
                    <div class="bar"></div>
                  </div>
                </div>

                <div v-if="step == 'step1'">
                  <div class="a_sec_1">
                    <div class="txt_1">잠깐!</div>
                    <div class="txt_2">
                      만약 지원금을 받지 못하면<br />어떡하나요?
                    </div>
                  </div>

                  <div class="a_sec_2">
                    <div class="sec_wrap">
                      <div class="img_1">
                        <img
                          :src="
                            require('@/assets/front/images/v2/tag_guarantee.png')
                          "
                          alt=""
                        />
                      </div>
                      <div class="txt_1">
                        <div>
                          {{ item.store.storeName }}은<br />퍼스 지급 보장
                          매장입니다.
                        </div>
                      </div>
                      <div class="txt_2">
                        퍼스지급보장이란 매장과 약속한 인터넷 지원금을 받지 못할
                        경우, <span>퍼스가 대신 지급을 보장하는 제도</span>이며,
                        <span>설치 당일 지급을 원칙</span>으로 합니다!
                      </div>
                      <div class="txt_3">
                        *설치 시간, 인증 시간에 따라 익일 지급될 수 있습니다.
                      </div>
                    </div>
                  </div>

                  <div class="a_sec_3">
                    <div class="txt_1">
                      고객님의 설치 희망일은<br /><span>{{
                        getDate(item.installDate)
                      }}</span
                      >이며,<br />약속 지원금은
                      <span>{{ item.supportTotal | comma }}원</span> 입니다.
                    </div>
                  </div>

                  <div class="a_sec_4">
                    <div class="sec_wrap">
                      <div class="img_1">
                        <img
                          :src="
                            require('@/assets/front/images/v2/img_bell_1.png')
                          "
                          alt=""
                        />
                      </div>
                      <div class="txt_1">
                        지원금 지급 확인을 잊지 않게<br /><span>{{
                          getInstallDateNext(item.installDate)
                        }}</span
                        >에<br />알림톡을 보내드려요!
                      </div>
                    </div>
                  </div>

                  <div class="a_sec_5">
                    <div class="txt_1">필수!</div>
                    <div class="txt_2">알림톡에 꼭 응답을 해주세요!</div>
                  </div>

                  <div class="a_sec_6">
                    <div class="sec_wrap">
                      <div class="txt_top">
                        설치희망일 기준 4일 이내에 답변을 주시면,<br />지원금을
                        받지 못하셨을때 퍼스가 신속하게 도와 드릴 수 있어요!
                      </div>
                      <div class="sec_con">
                        <div class="con_img">
                          <img
                            :src="
                              require('@/assets/front/images/v2/img_finger_01.png')
                            "
                            alt=""
                          />
                        </div>
                        <div class="con_txt">
                          <div class="txt_1">잘 입금 되었다면?</div>
                          <div class="txt_2">> 입금 확인 하기!</div>
                        </div>
                      </div>
                      <div class="sec_con">
                        <div class="con_img">
                          <img
                            :src="
                              require('@/assets/front/images/v2/img_finger_02.png')
                            "
                            alt=""
                          />
                        </div>
                        <div class="con_txt">
                          <div class="txt_1">설치 날짜를 변경 했다면?</div>
                          <div class="txt_2">
                            > 퍼스에게 변경된 설치 날짜 알려주기!
                          </div>
                          <div class="txt_3">
                            바뀐 설치일 다음날에 다시 알림톡을 보내드립니다!
                          </div>
                        </div>
                      </div>
                      <div class="sec_con">
                        <div class="con_img">
                          <img
                            :src="
                              require('@/assets/front/images/v2/img_finger_03.png')
                            "
                            alt=""
                          />
                        </div>
                        <div class="con_txt">
                          <div class="txt_1">지원금을 받지 못했다면?</div>
                          <div class="txt_2">> 퍼스에 신고해 주세요!</div>
                          <div class="txt_3">
                            퍼스에서 빠르게 도움을 드리겠습니다!
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="a_sec_7">
                    거래 종료 후에 퍼스에 알릴 시<br />도움을 드리는 과정에서
                    보다 복잡한 과정이 진행됩니다.
                  </div>

                  <div class="a_sec_8">
                    <div class="sec_txt">나의 신청 내역 확인!</div>
                    <div class="sec_wrap">
                      <div class="a_con">
                        <div class="con_li">
                          <div class="li_title">거래매장</div>
                          <div class="li_con">{{ item.store.storeName }}</div>
                        </div>
                        <div class="con_li">
                          <div class="li_title">상품구성</div>
                          <div class="li_con">{{ item.item }}</div>
                        </div>
                        <div class="con_li">
                          <div class="li_title">설치지역</div>
                          <div class="li_con">{{ getArea(item.address) }}</div>
                        </div>
                        <div class="con_li">
                          <div class="li_title">설치희망일</div>
                          <div class="li_con">
                            {{ getDate(item.installDate) }}
                          </div>
                        </div>
                        <div class="con_li">
                          <div class="li_title">약속지원금</div>
                          <div class="li_con">
                            {{ item.supportTotal | comma }}원
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="re_btn_wrap" v-if="step == 'step2'">
                  <button class="re_btn" @click="goToReviewWrite(item)">
                    리뷰하기
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { ko as dateKo } from 'date-fns/locale';

export default {
  name: 'InternetApplyPopup',
  props: {
    show: Boolean,
    step: String,
    item: Object,
  },
  components: {},
  data(props) {
    return {
      currentScrollTop: 0, // 터치시 현재 스크롤 상단 위치
      currentTouchStart: 0, // 터치시 현재 시작점
      currentTouchMove: 0, // 터치 후 이동점
      popupCloseReady: false, // 팝업 닫기 준비 되었는지
      applyConHeight: 0, // 팝업 height
    };
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  created() {},
  computed: {},
  mounted() {
    window.addEventListener('touchmove', e => {
      if (this.show) {
        const applyCon = document.querySelector('#apply_con');

        const scrollTop = applyCon.pageYOffset || applyCon.scrollTop;

        const touchClientY = e.touches[0].pageY;

        this.currentTouchMove =
          parseInt(touchClientY, 10) - parseInt(this.currentTouchStart, 10);

        if (this.currentScrollTop == 0 && this.currentTouchMove > 0) {
          applyCon.style.height =
            (
              parseInt(this.applyConHeight) - parseInt(this.currentTouchMove)
            ).toString() + 'px';

          this.popupCloseReady = true;
        } else {
          applyCon.style.height = this.applyConHeight.toString() + 'px';
          this.popupCloseReady = false;
        }
      }
    });
    window.addEventListener('touchstart', e => {
      if (this.show) {
        const applyCon = document.querySelector('#apply_con');

        this.applyConHeight = applyCon.clientHeight;

        const scrollTop = applyCon.pageYOffset || applyCon.scrollTop;

        this.currentScrollTop = scrollTop;

        this.currentTouchStart = e.touches[0].pageY;

        this.popupCloseReady = false;
      }
    });
    window.addEventListener('touchend', e => {
      if (this.show) {
        if (this.popupCloseReady) {
          const applyCon = document.querySelector('#apply_con');

          this.applyPopupClose();
        }
      }
    });
    window.addEventListener('touchcancel', () => {});
  },
  beforeDestroy() {
    window.removeEventListener('touchmove', () => {});
    window.removeEventListener('touchstart', () => {});
    window.removeEventListener('touchcancel', () => {});
    window.removeEventListener('touchend', () => {});
  },
  methods: {
    applyPopupClose() {
      this.$emit('close');
    },
    getDate(installDate) {
      const iDate = new Date(installDate);
      return format(iDate, 'yyyy.MM.dd (E)', { locale: dateKo });
    },
    getDeadline(installDate) {
      const iDate = new Date(installDate);
      const sDays = format(
        new Date(iDate.setDate(iDate.getDate() + 3)),
        'yyyy-MM-dd',
      );

      return sDays;
    },
    getInstallDateNext(installDate) {
      const iDate = new Date(installDate);
      return format(
        new Date(iDate.setDate(iDate.getDate() + 1)),
        'yyyy.MM.dd (E)',
        { locale: dateKo },
      );
    },
    getArea(address) {
      let strArr = address.split(' ');
      return strArr[0] + ' ' + strArr[1];
    },
    goToReviewWrite(item) {
      this.$emit('review-write', item);
    },
  },
};
</script>
